import { Injectable } from '@angular/core';

import { ApiService, AuthService } from '../core/upgraded-providers';

@Injectable()
export class UserService {
    constructor(
        private _apiSrv: ApiService,
        private _authSrv: AuthService
    ) {
    }

    async activateCpuUnlock(count: number) {
        try {
            await this._apiSrv.post('user/activate-cpu-unlocks', { count });
        } catch (err) {
            let message;
            if (typeof err === 'string') {
                message = err;
            } else {
                message = (err && err.data && err.data.error) || 'Error';
            }

            throw new Error(message);
        }

        this._authSrv.check();
    }
}
